import React from 'react';
import { connect } from 'react-redux';
import SMStream from 'dash-front/components/sm/streams/SMStream2';
import _ from 'lodash';

const simpleEventWidgets = tournamentId =>
    _.compact([
        'MatchAnnouncement',
        +tournamentId != 46 && 'PreMatchStatsSMWidget',
        +tournamentId != 46 && 'PreMatchStatsV7',
        +tournamentId === 46 && 'ProPreMatchStatsSMWidget',
        +tournamentId === 46 && 'ProLiveMatchStatsSMWidget',
        'AnimatedMatchAnnouncement',
        'AnimatedMatchAnnouncementTextual',
        'AnimatedMatchAnnouncementV2SMWidget',
    ]);

const statusWidgets = tournamentId =>
    _.compact(['MatchStarted', +tournamentId === 46 ? 'ProLiveMatchStatsSMWidget' : 'MatchStats', 'MatchFinished']);

const presentingTeams = event => [
    {
        name: 'TeamH2HTopScorersX3V4',
        groupKey: `ts-h2h-current`,
        props: {
            eventId: event.eventId,
            tournamentId: event.tournamentTemplateId,
            seasonId: event.tournamentId,
        },
        groupTitle: `${event.tournamentName} ${event.tournamentYear} H2H topscorers`,
    },

    {
        name: 'TeamH2HTopScorersX3V4',
        props: {
            eventId: event.eventId,
            tournamentId: event.tournamentTemplateId,
            currentSeason: false,
        },
        groupKey: `ts-h2h-all`,
        groupTitle: `H2H topscorers in ${event.tournamentName}`,
    },
    {
        name: 'TeamSeasonTopScorersSMWidget',
        props: {
            eventId: event.eventId,
            teamId: event.homeId,
            tournamentId: event.tournamentTemplateId,
            seasonId: event.tournamentId,
        },
        groupKey: `ts-${event.homeName}-season`,
        groupTitle: `${event.tournamentName} ${event.tournamentYear} ${event.homeShortName} topscorers`,
    },

    {
        name: 'TeamSeasonTopScorersSMWidget',
        props: {
            eventId: event.eventId,
            teamId: event.awayId,
            tournamentId: event.tournamentTemplateId,
            seasonId: event.tournamentId,
        },
        groupKey: `ts-${event.awayName}-season`,
        groupTitle: `${event.tournamentName} ${event.tournamentYear} ${event.awayShortName} topscorers`,
    },
    {
        name: 'TeamSeasonTopScorersSMWidget',
        props: {
            eventId: event.eventId,
            tournamentId: event.tournamentTemplateId,
            teamId: event.homeId,
            currentSeason: false,
        },
        groupKey: `ts-${event.homeName}-all`,
        groupTitle: `${event.homeShortName} ${event.tournamentName} topscorers  `,
    },

    {
        name: 'TeamSeasonTopScorersSMWidget',
        props: {
            eventId: event.eventId,
            tournamentId: event.tournamentTemplateId,
            teamId: event.awayId,
            currentSeason: false,
        },
        groupKey: `ts-${event.awayName}-all`,
        groupTitle: `${event.awayShortName} ${event.tournamentName} topscorers `,
    },
];

class EventSMB extends React.Component {
    constructor(props, context) {
        super(props, context);
    }

    componentDidMount = () => {};

    state = {};

    render() {
        const {
            params: { eventId, tournamentId },
            event,
        } = this.props;

        return (
            <div>
                <SMStream
                    key={'inf_' + eventId}
                    smWidgets={simpleEventWidgets(tournamentId).map(name => ({
                        name,
                        props: { eventId },
                    }))}
                    title="Announcments"
                />

                <SMStream
                    key={'statuses_' + eventId}
                    smWidgets={statusWidgets(tournamentId).map(name => ({
                        name,
                        props: { eventId },
                    }))}
                    title="Statuses"
                />

                <SMStream
                    key={'presenting_teams_' + eventId}
                    smWidgets={presentingTeams(event)}
                    title="Presenting teams"
                />
            </div>
        );
    }
}

export default connect(state => ({
    event: state.smBrowser.event,
}))(EventSMB);



/** WEBPACK FOOTER **
 ** ../src/dash/front/components/sm/pages/event/EventSMB.js
 **/